import baseService from "./base.service";


const analytics = {
    getAnalytics : function(){
        return baseService.request(axios.get('admin/analytics'))
    }
}

export  default analytics